jQuery(($) => {
    if ($('.o-product-archive__filter-bar')[0]) {
        var select = $(this).find('.m-filter-bar__select'),
            form   = $(this).find('.m-filter-bar__form');

        select.each(function(){
            $(this).change(function () {
                form.submit();
            });
        });
    }
});